// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"c4ac6c01","161":"d6cbbc74","239":"e7a2ff17","241":"4ccf650d","355":"2fe5ef9f","396":"d8b5ea80","455":"45a8e1bf","673":"b7652330","715":"d491460f","722":"c4662f89","857":"44e4468d","882":"15713619","889":"3d0c8fbb","977":"a723575a"}[chunkId] + ".chunk.js";
};